import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptyTransactionModel, ITransactionModal, ITransactionOrder } from "./TransactionsApp";
import { ISearchParam } from "../BaseApp";

export interface ITransactionSavedDetails {
    itemId?: number | null,
    fromWarehouse?: number | null,
    fromSection?: number | null,
    fromLocation?: number | null,
    fromUser?: number | null,
    type?: string,
    action?: string,
    fromType?: string,
}

export interface ITranscationDetailsDialog {
    shown: boolean,
    transaction: ITransactionModal
}

interface ITransactionsState {
    transactions: Array<ITransactionModal>,
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string,
    showOrders: boolean,
    orders: ITransactionOrder[],
    savedDetails: ITransactionSavedDetails,
    triggerModalOpen: boolean,
    modalOpenStatus: boolean,
    triggerTranscationsRefresh: boolean,
    transcationDetailsModal: ITranscationDetailsDialog,
    selectedTransactions: ITransactionModal[],
    searchParams: ISearchParam[],
}

const initialState: ITransactionsState = {
    transactions: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    },
    showOrders: false,
    orders: [],
    savedDetails: {
        // itemId: null,
        // fromWarehouse: null,
        // fromSection: null,
        // fromLocation: null,
        // fromUser: null,
    },
    triggerModalOpen: false,
    modalOpenStatus: false,
    triggerTranscationsRefresh: false,
    transcationDetailsModal: {
        shown: false,
        transaction: EmptyTransactionModel
    },
    selectedTransactions: [],
    searchParams: [],
}

const transactionsSlice = createSlice({
    name: "transactions",
    initialState,
    reducers: {
        updateAllTransactions: (state: ITransactionsState, action: PayloadAction<Array<ITransactionModal>>) => {
            state.transactions = action.payload
        },
        updateAllTransactionsOrders: (state: ITransactionsState, action: PayloadAction<Array<ITransactionOrder>>) => {
            state.orders = action.payload
        },
        addNewTransaction: (state: ITransactionsState, action: PayloadAction<ITransactionModal>) => {
            let transactions = state.transactions

            if (transactions.filter(transaction => transaction.id === action.payload.id).length === 0){
                // state.transactions.push(action.payload)
                transactions = [
                    action.payload,
                    ...transactions,
                ]
            }

            state.transactions = transactions

        },
        addNewTransactionOrder: (state: ITransactionsState, action: PayloadAction<ITransactionOrder>) => {
            let orders = state.orders

            if (orders.filter(order => order.id === action.payload.id).length === 0){
                // state.transactions.push(action.payload)
                orders = [
                    action.payload,
                    ...orders,
                ]
            }

            state.orders = orders

        },
        deleteTransaction: (state: ITransactionsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let transactions = state.transactions

            transactions = transactions.filter(transaction => transaction.id !== payload.id)

            state.transactions = transactions

        },
        deleteTransactionOrder: (state: ITransactionsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let orders = state.orders

            orders = orders.filter(order => order.id !== payload.id)

            state.orders = orders

        },
        updateTransaction: (state: ITransactionsState, action: PayloadAction<ITransactionModal>) => {
            let transactions = state.transactions
            
            if (transactions && transactions.length > 0){
                transactions.map((transaction) => {
                    if (transaction.id === action.payload.id){

                        const locationIndex = transactions.findIndex(transaction => transaction.id === action.payload.id)
                        transactions[locationIndex] = action.payload

                    }
                })
            }

            state.transactions = transactions

        },
        updateTransactionOrder: (state: ITransactionsState, action: PayloadAction<ITransactionOrder>) => {
            let orders = state.orders
            
            if (orders && orders.length > 0){
                orders.map((order) => {
                    if (order.id === action.payload.id){

                        const locationIndex = orders.findIndex(order => order.id === action.payload.id)
                        orders[locationIndex] = action.payload

                    }
                })
            }

            state.orders = orders

        },
        updateTransactionsLoadingStatus: (state: ITransactionsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateTransactionsPagination: (state: ITransactionsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateTransactionsSearch: (state: ITransactionsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateTransactionSavedDetails: (state: ITransactionsState, action: PayloadAction<ITransactionSavedDetails>) => {
            state.savedDetails = action.payload
        },
        resetTansactionSavedDetails: (state: ITransactionsState, action: PayloadAction<{}>) => {
            state.savedDetails = {}
        },
        updateTransactionTiggerModal: (state: ITransactionsState, action: PayloadAction<boolean>) => {
            state.triggerModalOpen = action.payload
        },
        updateTransactionModalStatus: (state: ITransactionsState, action: PayloadAction<boolean>) => {
            state.modalOpenStatus = action.payload
        },
        updateTransactionTriggerTranscationsRefresh: (state: ITransactionsState, action: PayloadAction<boolean>) => {
            state.triggerTranscationsRefresh = action.payload
        },
        updateTransactionDetailsModalStatus: (state: ITransactionsState, action: PayloadAction<boolean>) => {
            state.transcationDetailsModal.shown = action.payload
        },
        updateTransactionDetailsModalDetails: (state: ITransactionsState, action: PayloadAction<ITransactionModal>) => {
            state.transcationDetailsModal.transaction = action.payload
        },
        updateTransactionSearchParams: (state: ITransactionsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedTranscations: (state: ITransactionsState, action: PayloadAction<ITransactionModal[]>) => {
            state.selectedTransactions = action.payload
        },
    }
})

/**
 * Return all transactions
 */
export const useReturnAllTransactions = () => useSelector((state: RootState) => state.transactions.transactions)

/**
 * Return all transactions order
 */
export const useReturnAllTransactionOrders = () => useSelector((state: RootState) => state.transactions.orders)

/**
 * Retrun single transaction
 */
export const useReturnSingleTransaction = (id: number) => {
    const transactions = useReturnAllTransactions()

    let transaction: ITransactionModal = EmptyTransactionModel

    if (transactions.length > 0){
        transactions.map((singleTransaction) => {
            if (singleTransaction.id === id){
                transaction = singleTransaction
            }
        })
    }

    return transaction

}

/**
 * Return transactions loading status
 */
export const useReturnTransactionsLoadingStatus = () => useSelector((state: RootState) => state.transactions.loading)

/**
 * Return transactions pagination
 */
export const useReturnTransactionsPagination = () => useSelector((state: RootState) => state.transactions.pagination)

/**
 * Return transactions search
 */
export const useReturnTransactionsSearch = () => useSelector((state: RootState) => state.transactions.search)

/**
 * Return transactions search params
 */
export const useReturnTransactionsSearchParams = () => useSelector((state: RootState) => state.transactions.searchParams)

/**
 * Return selected transactions
 */
export const useReturnSelectedTransactions = () => useSelector((state: RootState) => state.transactions.selectedTransactions)

export const { updateAllTransactions, addNewTransaction, deleteTransaction, updateTransaction, updateTransactionsLoadingStatus, updateTransactionsPagination, updateTransactionsSearch, addNewTransactionOrder, deleteTransactionOrder, updateTransactionOrder, updateAllTransactionsOrders, updateTransactionSavedDetails, updateTransactionTiggerModal, updateTransactionModalStatus, resetTansactionSavedDetails, updateTransactionTriggerTranscationsRefresh, updateTransactionDetailsModalStatus, updateTransactionDetailsModalDetails, updateTransactionSearchParams, setSelectedTranscations } = transactionsSlice.actions
export default transactionsSlice.reducer